export const LEGAL_PAYMENT_PROCESSING: string = `

### <!--= ++sectionIndex -->. Payment Processing
<!-- subSectionIndex = 0; -->

<!-- if (payment.providers.paddle) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Paddle

We uses Paddle.com as a payment service provider to process online transactions on our website.

When you conduct a transaction on our website, Paddle collects certain personal data necessary for the payment process and contractual obligations. This data may include your name, email address, billing address, payment information, and purchase details.

Paddle may also use cookies or similar technologies to facilitate and personalize your shopping experience, such as by remembering your preferences and recognizing you on return visits.

Paddle processes this data in compliance with their Privacy Policy, which we recommend you review for a comprehensive understanding of their data collection, use, and privacy practices: [Paddle's Privacy Policy](https://paddle.com/privacy).

We want to stress that the data you provide during the payment process is handled directly by Paddle, and we do not have access to your complete payment information.
<!-- } -->

<!-- if (payment.providers.stripe) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Stripe

We use the payment processing service Stripe to handle payment transactions on our website. Stripe is a service provided by Stripe Payments Europe, Ltd, 1 Grand Canal Street Lower, Grand Canal Dock, Dublin.

When you choose to make a payment through our website, the payment information that you provide will be transmitted to Stripe for the purpose of processing the payment. You have the option to revoke your consent at any time with future effect. Revoking your consent does not affect the legality of the past data processing operations.

Stripe uses the data transmitted to it to perform the payment processing service, including for fraud prevention and reporting purposes. Stripe may also transmit your data to credit agencies for identity and credit checks.

For more detailed information on how Stripe handles user data, please refer to Stripe's Privacy Policy, available at [https://stripe.com/privacy](https://stripe.com/privacy).
<!-- } -->

<!-- if (payment.providers.paypal) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Paypal

We use PayPal as a payment processing services. PayPal is an online payments system operated by PayPal (Europe) S.à.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg.

When you elect to pay using PayPal, your payment data is transmitted to PayPal as part of the payment process. You have the option to withdraw your consent at any time with effect for the future. Revocation does not affect the legitimacy of data processing in the past.

PayPal uses the transmitted data to process payments and carry out fraud prevention and creditworthiness checks. As part of its services, PayPal may pass your data onto third parties, such as credit reference agencies.

For more detailed information regarding the handling of user data, please refer to PayPal's Privacy Policy, available at [PayPal Privacy Policy](https://www.paypal.com/en/webapps/mpp/ua/privacy-full).
<!-- } -->

<!-- if (payment.affiliation.tapfiliate) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Tapfiliate Affiliate Tracking System

We uses the Tapfiliate tracking system provided by Tapfiliate Joop Geesinkweg 140, 1096 AT Duivendrecht, Netherlands. This service helps us manage our affiliate marketing program.

When you visit our website through an affiliate link, Tapfiliate sets a cookie on your device to track the referral. This cookie stores an identification code for the affiliate and the specific marketing campaign.

Additionally, Tapfiliate may collect and process certain data, such as your IP address, device information, and details about the webpage that led you to our website. This information is used to measure the effectiveness of our affiliate marketing campaigns and to compensate our affiliates.

We want to stress that the data collected by Tapfiliate is processed in accordance with their Privacy Policy, which we recommend you review: [Tapfiliate's Privacy Policy](https://tapfiliate.com/privacy/).
<!-- } -->
`;
